import { useContext } from 'react'

import { SchoolContext } from '../../../Providers/SchoolProvider'
import SearchList from '../../antd/Lists/SearchList'
import EntityBadge, { getEntityRank } from '../Badges/EntityBadge'

const InstitutionsList = ({ bordered, excluded = null, pinned = null, selected, maxHeight, onSelectedChange }) => {
  const { unmanagedInstitutions } = useContext(SchoolContext)

  const institutionOptions = unmanagedInstitutions
    .filter(institution => institution.id !== excluded)
    .sort((a, b) => {
      /** A place proposed as a duplicate opens the list : one pre-selected halfway down is one nobody ever sees. */
      if (pinned !== null && (a.id === pinned || b.id === pinned)) {
        return a.id === pinned ? -1 : 1
      }

      const rankDiff = getEntityRank(a) - getEntityRank(b)

      if (rankDiff !== 0) {
        return rankDiff
      }

      return (a.name ?? '').localeCompare(b.name ?? '')
    })
    .map(institution => ({
      label: (
        <span className='flex-row ai-ctr' style={{ gap: 5 }}>
          {institution.name}
          <EntityBadge entity={institution} size='sm' withTooltip />
        </span>
      ),
      value: institution.id,
      tooltip: institution.name
    }))

  return (
    <div className='h-100'>
      <SearchList
        selected={selected}
        data={institutionOptions}
        maxHeight={maxHeight}
        onSelectedChange={onSelectedChange}
      />
    </div>
  )
}

export default InstitutionsList
